import { Button, ButtonProps, styled } from "@mui/material";
import React from "react";

export const CustomButton = styled((props: ButtonProps) => (
  <Button {...props} />
))(({ theme }) => ({
  textTransform: "none",
  ":disabled": {
    border: "1px solid #676767"
  },
  "&.MuiButton-root": {
    // color: "#fff",
    // color: theme.palette.mode === "dark" ? "#000" : "#000",
    // backgroundColor: theme.palette.mode === "dark" ? "#C4C7C4" : "#fff",
  },
}));


